import React, { useEffect } from "react";
import { Tooltip } from "@material-ui/core";
import BandwidthBox from "./bandwidthBox";
import NetworkElementBox from "./networkElementBox";
import SwipeIcon from "../../assets/images/swipe-icon.svg";
import { useGroup } from "../ManagePorts/GroupOperations/useGroup";

interface AddBandwidthFormProps {
  bandwidthDescription: string;
  fePortDescription: string;
  nePortDescription: string;
  noOfLinksError: string;
  noOfLinksApiError: string;
  noOfLinksToAdd: number | string;
  neNetworkElementOptions: any[];
  feNetworkElementOptions: any[];
  selectedNeNetworkElement: any;
  selectedFeNetworkElement: any;
  tempPortTypeId: any;
  portTypeOptions: any[];
  nePortsInfo: any[];
  fePortsInfo: any[];
  linkPortsInfo: any[];
  verifyNearendPorts: boolean;
  verifyFarendPorts: boolean;
  onFeNetworkElementChange: (value: any) => void;
  onNeNetworkElementChange: (value: any) => void;
  onBandwidthDescriptionChange: (_: any) => void;
  onFePortDescriptionChange: (_: any) => void;
  onNePortDescriptionChange: (_: any) => void;
  onPortTypeChange: (portTypeId: number) => void;
  onNePortNameChange: (portTempId: number, portName: string) => void;
  onFePortNameChange: (portTempId: number, portName: string) => void;
  onLinkPortNameChange: (portTempId: number, portName: string) => void;
  onNoOfLinksChange: (_: any) => void;
  onKeypress: (_: any) => void;
  onSwipeClick: () => void;
  handleFEVerifyChange: () => void;
  handleNEVerifyChange: () => void;
  neInput: string;
  feInput: string;
  handleNEInputChange: (_: string) => void;
  handleFEInputChange: (_: string) => void;
  neUseGroupProps: ReturnType<typeof useGroup>;
  feUseGroupProps: ReturnType<typeof useGroup>;
  nePortPrefix: string;
  fePortPrefix: string;
  linkPrefix: string;
  handleNePortPrefixChange: (_: string) => void;
  handleFePortPrefixChange: (_: string) => void;
  handleLinkPrefixChange: (_: string) => void;
}

const AddBandwidthForm: React.FC<AddBandwidthFormProps> = ({
  neInput,
  feInput,
  neUseGroupProps,
  feUseGroupProps,
  onLinkPortNameChange,
  linkPortsInfo,
  handleNEInputChange,
  handleFEInputChange,
  verifyNearendPorts,
  verifyFarendPorts,
  handleFEVerifyChange,
  handleNEVerifyChange,
  bandwidthDescription,
  fePortDescription,
  nePortDescription,
  tempPortTypeId,
  noOfLinksError,
  onPortTypeChange,
  noOfLinksApiError,
  noOfLinksToAdd,
  neNetworkElementOptions,
  feNetworkElementOptions,
  selectedNeNetworkElement,
  selectedFeNetworkElement,
  portTypeOptions,
  nePortsInfo,
  fePortsInfo,
  onBandwidthDescriptionChange,
  onFePortDescriptionChange,
  onNePortDescriptionChange,
  onNoOfLinksChange,
  onFePortNameChange,
  onNePortNameChange,
  onKeypress,
  onNeNetworkElementChange,
  onFeNetworkElementChange,
  onSwipeClick,
  nePortPrefix,
  fePortPrefix,
  linkPrefix,
  handleNePortPrefixChange,
  handleFePortPrefixChange,
  handleLinkPrefixChange,
}) => {
  const bandwidthBoxProps = {
    portTypeOptions,
    tempPortTypeId,
    onPortTypeChange,
    bandwidthDescription,
    linksError: noOfLinksApiError || noOfLinksError,
    noOfLinksToAdd,
    onBandwidthDescriptionChange,
    onNoOfLinksChange,
    onKeypress,
  };
  return (
    <div className="form-section-root">
      {/* <div className="bandwidth-info-box-root">
        <label>Link Details</label>
        <BandwidthBox {...bandwidthBoxProps} />
      </div> */}
      <div className="network-elements-info-box-root">
        <div className="near-end-ne">
          <NetworkElementBox
            title="Near End Port Details"
            verifyPorts={verifyNearendPorts}
            handleVerifyChange={handleNEVerifyChange}
            onNetworkElementChange={onNeNetworkElementChange}
            onInputChange={handleNEInputChange}
            inputValue={neInput}
            onPortNameChange={onNePortNameChange}
            onKeypress={onKeypress}
            onPortDescriptionChange={onNePortDescriptionChange}
            portDescription={nePortDescription}
            networkElementOptions={neNetworkElementOptions}
            selectedNetworkElement={selectedNeNetworkElement}
            portsInfo={nePortsInfo}
            useGroupProps={neUseGroupProps}
            portPrefix={nePortPrefix}
            handlePortPrefixChange={handleNePortPrefixChange}
          />
        </div>
        <div className="link-box">
          <NetworkElementBox
            bandwidthProps={bandwidthBoxProps}
            title="Link Details"
            verifyPorts={false}
            handleVerifyChange={() => {}}
            onNetworkElementChange={() => {}}
            onInputChange={() => {}}
            inputValue=""
            onPortNameChange={onLinkPortNameChange}
            onKeypress={onKeypress}
            onPortDescriptionChange={() => {}}
            portDescription=""
            networkElementOptions={[]}
            selectedNetworkElement={() => {}}
            portsInfo={linkPortsInfo}
            portPrefix={linkPrefix}
            handlePortPrefixChange={handleLinkPrefixChange}
          />
        </div>
        <div className="far-end-ne">
          <NetworkElementBox
            title="Far End Port Details"
            onNetworkElementChange={onFeNetworkElementChange}
            onInputChange={handleFEInputChange}
            inputValue={feInput}
            onPortNameChange={onFePortNameChange}
            onKeypress={onKeypress}
            onPortDescriptionChange={onFePortDescriptionChange}
            portDescription={fePortDescription}
            networkElementOptions={feNetworkElementOptions}
            selectedNetworkElement={selectedFeNetworkElement}
            portsInfo={fePortsInfo}
            verifyPorts={verifyFarendPorts}
            handleVerifyChange={handleFEVerifyChange}
            useGroupProps={feUseGroupProps}
            portPrefix={fePortPrefix}
            handlePortPrefixChange={handleFePortPrefixChange}

          />
        </div>
      </div>
    </div>
  );
};

export default AddBandwidthForm;
